export const SCHEMA_VERSION_KEY = 'schemaVersion';
export const RECIPE_VERSION_KEY = 'recipeVersion';
